// GTM triggers match snake_case names: "PWS experiment expose" -> pws_experiment_expose.
function toDataLayerEvent(event) {
  return event.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_');
}

/** @type {import('./index').AnalyticsDestination} */
export const dataLayerAdapter = {
  track(event, properties) {
    if (typeof window.dataLayer?.push !== 'function') return;

    window.dataLayer.push({ ...properties, event: toDataLayerEvent(event) });
  }
};
